import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import VueGoogleCharts from 'vue-google-charts';
import JsonViewer from 'vue-json-viewer';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Notifications from 'vue-notification';
import VueGAPI from 'vue-gapi';
import VueGeolocation from 'vue-browser-geolocation';
// import { GmapMarker } from 'vue2-google-maps/src/components/marker';
import * as VueGoogleMaps from 'vue2-google-maps';
import AudioVisual from 'vue-audio-visual';
import '@mdi/font/css/materialdesignicons.css';
import { StreamBarcodeReader } from "vue-barcode-reader";
import VueConfetti from 'vue-confetti';
// import * as Cesium from 'cesium';
// import streamhttp from 'stream-http';
// import Viewer from "cesium/Source/Widgets/Viewer/Viewer";
// const viewer = new Viewer("cesiumContainer");
// Vue.use(viewer);

Vue.use(VueConfetti);
// Vue.use(Cesium);
// Vue.use(streamhttp);
import SequentialEntrance from 'vue-sequential-entrance';
import 'vue-sequential-entrance/vue-sequential-entrance.css';
Vue.use(SequentialEntrance);

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: "#78cce2",
        primary2: "#3e90a5",
        primary3: "#1e5a6f",
        color: "#1e1e1e",
        accent: "#7CB342",
        secondary: "#0c161b",
        secondary2: "#0c161b",
        secondary3: "#0c161b",
        success: "#4CAF50",
        info: "#6156d8",
        warning: "#1565C0",
        error: "#FF7043",
        nav: "#0c161b",
        bar: "#0c161b",
      },
      light: {
        primary: "#0c161b",
        primary2: "#162831",
        primary3: "#1e5a6f",
        accent: "#a1e754",
        secondary: "#fff",
        secondary2: "#4c5c60",
        secondary3: "#304057",
        success: "#6dff74",
        info: "#304057",
        warning: "#2e8ac0",
        error: "#ff5e3c",
      }
    },
    options: {
      customProperties: true,
    },
  },
});
Vue.use(Vuetify);
Vue.use(Notifications);
Vue.use(StreamBarcodeReader);
Vue.use(VueGoogleCharts);
Vue.use(AudioVisual);

Vue.use(JsonViewer);
Vue.config.productionTip = false;
window.Event = new Vue();

// Use the plugin and pass along the configuration'
// create the 'options' object
const apiConfig = {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest'],
  // see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
  scope: 'https://www.googleapis.com/auth/gmail.send',
  refreshToken: true,
};
Vue.use(VueGAPI, apiConfig);
Vue.use(VueGeolocation);
// Vue.component('GmapMarker', GmapMarker);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'places',
  },
});

Vue.config.productionTip = false;
new Vue({
  store,
  router,
  vuetify: new Vuetify({}),
  render: (h) => h(App),
}).$mount('#app');